<template>
	<div class="masterCon" >
		  
			  <div class="top">
				  <Button type="success" class="addButton"  @click="addData(1)" style="margin-right:8px;">{{$t("BasicProduct.basicClassBox.title")}}</Button>
				  <Button  type="primary" :disabled="buttonList.editDisabled" class="addButton" @click="addData(2)" style="margin-right: 8px" >{{ $t("edit") }}</Button>
				  <Button  type="error" :disabled="buttonList.editDisabled" class="addButton" @click="delData(2)" style="margin-right: 8px" >{{ $t("delete") }}</Button>
			  </div>
	  
			  <Table  :columns="titleName" :data="tableList.tableData"  @on-selection-change="selectChange"  @on-sort-change="sortCustom" ref="selection"  :loading='loading'></Table>
	  
			  <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,20,30,50]" placement="top" class="pages"/>
  
			<!-- 添加  经销商账户 -->
		    <ModelBox  :offModel.sync='offModel' :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData"></ModelBox>
		    
			<!-- 删除 -->
			<DeleteDialog ref="deleteChild" @ievent="ievent"></DeleteDialog>
  
	</div>
  </template>
  <script>
  import common from '@/common/common.js';
  import axios from 'axios'
//   import ModelBox from './component/addModelNew';
  import ModelBox from './component/addUserModel';
  import DeleteDialog from "@/views/common/deleteModel.vue"; // 引入删除弹框组件
  import moment from 'moment';
  import { mapMutations } from 'vuex'
  
	  export default {
		  name: "merchantAdmin",
		  components: {
			  ModelBox,
			  DeleteDialog
		  },
		  data(){
			  return{
				  loading: true,
				  paging: true,//分页是否是真的
				  type:1,//弹框打开类型 1添加 2编辑
				  tableList:{//表格组
					  hasSelectData:{},//已选中的行的数据
					  tableData: [],//表格数据
					  tableDataAll:[]
				  },
				  buttonList: {//按钮组
                     editDisabled: true, //编辑按钮是否禁用
                   },
				  addBox:{//规格弹框组-新增
					  showModel:false,//弹框开关
					  callbackFn:()=>{}, //弹框的回调函数
					  editFormData:{},//编辑时传入的现有数据
				  },
				  offModel: true,
				  page:{//分页排序
					  total:0,//总条数
					  pageSize:10,//每页条数
					  current:1,//当前页
					  key:'orderDate',
					  order:'desc'
				  }
			  }
		  },
		  computed:{
			  local(){
				 return this.$store.state.local
			  },
			  roleType(){
				  let res = '2'
				  if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
				   res = this.$store.state.uInfo.roleType
				  }
				  return res
			  },
			  searchObjArr(){
				  return   {
					  is_share:[
						  {id: 1,val:this.$t('selectList.functionCategoryList.Water_equipment')},
						  {id: 2,val:this.$t('selectList.functionCategoryList.Water_equipment')},
					  ]
				  }
			  },
			  titleName(){
				   return [
				      {
                        type: "selection",
                        width: 60,
                        align: "center",
                        fixed: "left",
                      },
					  {
						  title: this.$t('BasicProduct.funcBox.titleName.Name'),
						  key: 'nikeName',
						  minWidth: 180,
					  },
					  {
						  title: this.$t('setting.email'),
						  key: 'email',
						  minWidth: 240
					  },
					  {
						  title: this.$t('setting.registerTime'),
						  key: 'createDate',
						  minWidth: 180,
						  render:(h, params)=>{
							  let stext = moment(params.row.createDate*1).format('YYYY-MM-DD')
							   return h('div',stext || '')
						  }
					  }
				  ]
			  } 
		  },
		  created() {
			 
			  this.getData();
		 
		  },
		  watch: {
		  
		  },
		  methods: {
			  ...mapMutations([
				  'setSelectId',
				  'setShowChildrenSide',
				  'setTabMenuList',
				  'setTabMenuItem',
				  'setDealerToken'
		 
			  ]),
			  getData() {//获取数据
				  let params = {}
				  this.loading = true
				  this.axios.post(this.config.urlArray.getInstalls, params).then((result) => {

					  common.ajaxMsg(result.data,false,()=>{
						  let resData = result.data.data;
                            if (resData) {
                                 if (!resData.meta) {
                                   //分页不生效
                                   this.tableList.tableDataAll = resData;
                                   this.paging = false;
                                   this.page.total = result.data.data.length;
                                   this.getDataPage();
                                 } else {
                                   this.tableList.tableData = resData.productList
                                   this.page.total = resData.meta.count;
                                 }
                     
                                 this.loading = false;
                           } else {
                             this.tableList.tableData = [];
                             this.page.total = 0;
                             this.loading = false;
                             return false;
                           }
	  
						  this.loading = false
					  })
				  }).catch((err) => {
					  common.msg('error',err,()=>{
						this.loading = false
					  })
				  });
			  },
			  getDataPage() {
                 let start = (this.page.current - 1) * this.page.pageSize;
                 let end = this.page.current * this.page.pageSize;
                 let key = this.page.key;
                 let order = this.page.order;

                 this.page.total = this.tableList.tableDataAll.length;

                 this.tableList.tableDataAll = this.tableList.tableDataAll.sort((a, b) => {
                   if (order == "asc") {
                     return a[key] - b[key];
                   } else if (order == "desc") {
                     return b[key] - a[key];
                   }
                 });
                 this.tableList.tableData = this.tableList.tableDataAll.slice(start, end);
               },
			  addData(type) {  //添加或编辑数据
				  if(this.roleType==3) return
				  this.addBox.showModel = true
				  this.offModel = false
				  this.type = type
				  if(type == 2) {
					  this.addBox.editFormData = this.tableList.hasSelectData
				  }
				  this.addBox.callbackFn = () => {
					  this.addBox.showModel = false;
					  this.clearbtnStatus();
					  this.getData();
				  }
			  },
			  delData(item) {// 删除
				if(this.roleType==3) return
                this.$refs.deleteChild.showit();
              },
			  selectChange(res) {//控制编辑和删除按钮的可用状态
                // console.log(res,'44')
                if (res.length == 1) {
                  this.buttonList.editDisabled = false;
                  this.tableList.hasSelectData = res[0];
                } else if (res.length == 0) {
                  this.buttonList.editDisabled = true;
                  this.tableList.hasSelectData = {};
                } else {
                  this.buttonList.editDisabled = true;
                  this.tableList.hasSelectData = res[0];
                }
              },
              ievent() {// 删除
                // console.log("删除");
                let url = this.config.urlArray.deleteInstaller;
                this.axios
                  .post(url, { id: this.tableList.hasSelectData.id })
                  .then((result) => {
                    common.ajaxMsg(result.data, true, () => {
                      this.$refs.deleteChild.recancel();
                      this.clearbtnStatus();
                      this.getData();
                    });
                  })
                  .catch((err) => {
                    // common.msg('error',this.$t('failed'))
                  });
              },
			  clearbtnStatus() {//删除后清空编辑数据 与按钮状态
               this.buttonList.editDisabled = true;
               this.tableList.hasSelectData = {};
             },
	   
			  sortCustom(data) {//自定义排序
               this.page.key = data.key;
               this.page.order = data.order;
               if (this.paging) {
                  this.getData();
				} else {
				   this.page.current = 1
                   this.getDataPage();
               }
             },

             changePage(nowpage) {//切换分页
               this.page.current = nowpage;
               if (this.paging) {
                 this.getData();
               } else {
                 this.getDataPage();
               }
             },
             changeSize(nowSize) {//切换每页显示条数
               this.page.pageSize = nowSize;
               this.page.current = 1;
               if (this.paging) {
                 this.getData();
               } else {
                 this.getDataPage();
               }
             },
		  }
	  }
  </script>
  <style lang="less">
	  .top{
  
		  margin: 10px auto 30px
	  }
	  .pages{
  
		  margin: 30px auto
	  }
	  .masterCon{
  
		  background: #fff;
		  padding: 20px;
		  margin: 42px 40px 8px 10px
	  }
	  .addButton{
  
		  border-radius: 6px;
	  }
  </style>
  
  